import React, { useState, useRef, useEffect } from "react";
import { Text } from "../../../components/Text";
import "./styles.css";
import { ReactComponent as Darkthem } from "../../../assets/Darkthem.svg";
import { ReactComponent as GreenThem } from "../../../assets/Green.svg";
import { ReactComponent as Orange } from "../../../assets/Orange.svg";
import { ReactComponent as LightThem } from "../../../assets/LightThem.svg";
import { ReactComponent as Default } from "../../../assets/Default.svg";
import { ReactComponent as NavyThem } from "../../../assets/NavyThem.svg";
import { ReactComponent as InputBox } from "../../../assets/Input.svg";
import { Dialog } from "primereact/dialog";
import { CustomButton } from "../../../components/CustomButton";
import Themspreview from "./ThemsPreview";
import { HiCheckCircle } from "react-icons/hi";
import { API_GET_FILE_URL } from "../../../api/media.service";
import axios from "axios";
import {
  fetchWhiteLabelCompany,
  saveWhiteLabelCompany,
} from "../../../reducers/whitelabelSlices";
import { useDispatch } from "react-redux";
import { useLayout } from "../../../context/LayoutContext";

const Whitelabel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [logo, setLogo] = useState("");
  const [themsName, setThemsName] = useState("");
  const [termsUrl, setTermsUrl] = useState("");
  const [rightsUrl, setRightsUrl] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const fileInputRef = useRef(null);
  const [isLoding, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { toast } = useLayout();

  const handleLogoClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
    }
  };

  const handleRemoveLogo = (e) => {
    e.stopPropagation();
    setLogo("");
    if (fileInputRef.current) fileInputRef.current.value = "";
    setLogoUrl("");
  };

  const uploadImageFile = async () => {
    try {
      const resp = await API_GET_FILE_URL();

      const config = {
        onUploadProgress: (progressEvent) => {
          setUploadPercentage(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
        },
        headers: { "Content-Type": logo.type || "image/png" },
      };

      await axios.put(resp.data.src, logo, config);
      return resp.data.url;
    } catch (error) {
      console.error("Image upload failed:", error);
      return null;
    }
  };

  const fetchData = async () => {
    try {
      const res = await dispatch(fetchWhiteLabelCompany()).unwrap();
      if (res.success) {
        setLogoUrl(res.data?.logoUrl || "");
        setRightsUrl(res.data?.rights || "");
        setTermsUrl(res.data?.termsConditionLink || "");
        setThemsName(res.data?.themeName || "default");
      }
    } catch (error) {
      console.error("Failed to fetch white label data:", error);
    }
  };
  const handlethemsSave = (data) => {
    const payload = {
      themeName: data,
    };
    try {
      dispatch(saveWhiteLabelCompany(payload))
        .unwrap()
        .then((res) => {
          let Message_Success = res?.message;
          toast.current.show({ severity: "success", detail: Message_Success });
          fetchData();
          window.location.reload();
        });
    } catch (error) {}
  };
  const handleSave = async () => {
    let uploadedLogoUrl = logoUrl;

    try {
      if (logo instanceof File) {
        uploadedLogoUrl = await uploadImageFile();
        if (!uploadedLogoUrl) {
          console.error("Logo upload failed.");
          return;
        }
      }

      const payload = {
        logoUrl: uploadedLogoUrl || "",
        termsConditionLink: termsUrl.trim(),
        themeName: themsName || 'default',
        rights: rightsUrl.trim(),
      };

      await dispatch(saveWhiteLabelCompany(payload))
        .unwrap()
        .then((res) => {
          let Message_Success = res?.message;
          // toast.current?.show({ severity: "success", detail: Message_Success });
          fetchData();
          window.location.reload();
        });
    } catch (error) {
      console.error("Failed to save white label settings:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  return (
    <div>
      <div className="header_container">
        <div>
          <Text
            type="sub-heading"
            color="rgba(0, 0, 0, 1)"
            style={{ fontWeight: "600", fontSize: "14px" }}
          >
            Brand & Appearance
          </Text>
          <div className="mt-2">
            <span>
              Customize how SkaleBot looks for your customers. Tailor the
              interface to match your brand identity.
            </span>
          </div>
        </div>
        <div>
          <CustomButton label="Save" onClick={handleSave} />
        </div>
      </div>

      <div className="thems_container">
        {/* Theme Selection */}
        <Text
          type="sub-heading"
          color="rgba(0, 0, 0, 1)"
          style={{ fontWeight: "600", fontSize: "12px", marginTop: ".8rem" }}
        >
          Theme Selection
        </Text>
        <div className="mt-2">
          <span>
            Choose a color scheme that aligns with your brand identity
          </span>
        </div>

        <div className="grid-container">
          {[
            ["Default Theme", Default, "default"],
            ["Light Theme", LightThem, "light"],
            ["Orange Theme", Orange, "orange"],
            ["Navy Theme", NavyThem, "navy"],
            ["Green Theme", GreenThem, "green"],
            ["Dark Theme", Darkthem, "dark"],
          ].map(([label, Icon, key]) => {
            const isSelected = themsName === key;
            const isDisabled = key === "dark";

            return (
              <div
                key={key}
                className={`relative grid-item border rounded-md p-2 cursor-pointer transition group ${
                  isSelected
                    ? "border-dark-500 ring-2 ring-blue-300"
                    : "border-gray-200"
                } ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                <div className="themstitle">{label}</div>
                <div className="thems_card">
                  <Icon />
                </div>

                {!isDisabled &&  (
                  <div className={`theme-actions group-hover:flex ${key}`}>
                    <CustomButton
                      className="preview-button"
                      label={"Preview"}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(true);
                        setThemsName(key);
                      }}
                    >
                      Preview
                    </CustomButton>
                    {!isSelected && (
                      <CustomButton
                        className={`preview-button ${key}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handlethemsSave(key);
                        }}
                        label={"Activate"}
                      >
                        Activate
                      </CustomButton>
                    )}
                  </div>
                )}
                {isSelected && (
                  <div className="activated-label">{label} Activated</div>
                )}
              </div>
            );
          })}
        </div>

        {/* Logo Upload */}
        <Text
          type="sub-heading"
          style={{ fontWeight: "600", fontSize: "12px", marginTop: ".8rem" }}
        >
          Company Logo
        </Text>
        <div className="mt-2">
          <span>
            Upload your company logo to be displayed throughout the platform
          </span>
        </div>

        <div className="company_logo">
          <div
            className="thems_footer"
            onClick={!logo ? handleLogoClick : undefined}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const file = e.dataTransfer.files[0];
              if (file && file.type.startsWith("image/")) setLogo(file);
            }}
          >
            <input
              type="file"
              ref={fileInputRef}
              hidden
              onChange={handleFileChange}
              accept="image/*"
            />
            {logo || logoUrl ? (
              <div className="logo-preview-container">
                <img
                  src={logo ? URL.createObjectURL(logo) : logoUrl}
                  alt="Company Logo Preview"
                  className="logo-preview"
                />
                <div className="logo-details">
                  <span className="logo-name">{logo?.name}</span>
                  <button
                    className="remove-logo-btn"
                    onClick={handleRemoveLogo}
                  >
                    Re-upload
                  </button>
                </div>
              </div>
            ) : (
              <InputBox />
            )}
          </div>
        </div>

        {/* Terms URL */}
        <Text
          type="sub-heading"
          style={{ fontWeight: "600", fontSize: "12px", marginTop: ".8rem" }}
        >
          Terms & Conditions URL
        </Text>
        <div className="mt-2">
          <span>Link to your legal documentation that users must agree to</span>
        </div>
        <div className="term_condition">
          <input
            type="text"
            className="term_input"
            value={termsUrl}
            onChange={(e) => setTermsUrl(e.target.value)}
          />
        </div>

        {/* Rights Reserved */}
        <Text
          type="sub-heading"
          style={{ fontWeight: "600", fontSize: "12px", marginTop: ".8rem" }}
        >
          Company Name
        </Text>
        <div className="mt-2">
          <span>
            Define your company name that will appear in the footer of your
            application
          </span>
        </div>
        <div className="term_condition">
          <input
            type="text"
            className="term_input"
            value={rightsUrl}
            onChange={(e) => setRightsUrl(e.target.value)}
          />
        </div>
      </div>

      {/* Theme Preview Modal */}
      {isOpen && (
        <Dialog
          header="Theme Preview"
          visible={isOpen}
          onHide={() => setIsOpen(false)}
          draggable={false}
          footer={
            <div className="modal_footer">
              <CustomButton
                onClick={() => setIsOpen(false)}
                varient="text"
                label="Cancel"
              />
            </div>
          }
          style={{ height: "80vh" }}
        >
          <div className="modal-container">
            <Themspreview themsName={themsName} />
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default Whitelabel;
